// TODO: change the way of finding base group
var isBaseGroupLayer = function isBaseGroupLayer(layer) {
  return layer.id.startsWith('base');
};

export { isBaseGroupLayer as default };
